import { createActionGroup, emptyProps } from "@ngrx/store";

export const AppActions = createActionGroup({
    source: 'App',
    events: {
        'Started': emptyProps(),
    },
});

export const UserConfigsActions = createActionGroup({
	source: 'UserConfigs',
	events: {
		'Authenticated': emptyProps(),
		'Case Switched': emptyProps()
	},
});

